export function formatBatchLabel(containerCode: string | null | undefined): string {
  const trimmed = (containerCode ?? '').trim();
  if (trimmed === '') {
    return '';
  }

  const honeyMatch = /^H(?:INK)?\s*(\d+)$/i.exec(trimmed);
  if (honeyMatch) {
    return honeyMatch[1];
  }

  return trimmed;
}

export function formatContainerDisplayId(
  containerId: number | null | undefined,
  containerCode: string | null | undefined
): string {
  if (typeof containerId === 'number' && Number.isFinite(containerId) && containerId > 0) {
    const trimmed = (containerCode ?? '').trim();
    if (/^H(?:INK)?\s*\d+$/i.test(trimmed)) {
      return `H${containerId}`;
    }
    return String(containerId);
  }

  return formatBatchLabel(containerCode);
}
